import { format } from "date-fns"

export function parseJwt(token: string) {
  var base64Url = token.split(".")[1]
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join("")
  )

  return JSON.parse(jsonPayload)
}

export function download_csv(csv: any, filename: string) {
  var csvFile
  var downloadLink

  // CSV FILE
  csvFile = new Blob([csv], { type: "text/csv" })

  // Download link
  downloadLink = document.createElement("a")

  // File name
  downloadLink.download = filename

  // We have to create a link to the file
  downloadLink.href = window.URL.createObjectURL(csvFile)

  // Make sure that the link is not displayed
  downloadLink.style.display = "none"

  // Add the link to your DOM
  document.body.appendChild(downloadLink)

  // Lanzamos
  downloadLink.click()
}

export const formatDate = (date: Date | number, fmt: string = "d MMM yyy") => format(date, fmt)

// Mirrors reports-service PasswordValidator. The username rule is enforced by the backend only.
const PASSWORD_PATTERN = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&+=_-])[a-zA-Z0-9@#$%^&+=_-]{10,32}$/

export const isValidPassword = (password: string) =>
  PASSWORD_PATTERN.test(password)

export function exportCsv(columns: any, data: any, filename?: string) {
  // Only include columns that are not hidden
  const visibleColumns = columns.filter((col: any) => !col.hidden)
  const fields = visibleColumns.map((obj: any) => obj.field)
  let csv: string[] = []
  // Add header row with column titles
  csv.push(visibleColumns.map((obj: any) => obj.title).join(","))
  // Add data rows
  data.forEach((obj: any) => {
    csv.push(fields.map((field: string) => obj[field]).join(","))
  })
  const dateStr = formatDate(Date.now(), "yyyyMMddHHmm")
  const exportFilename = `${filename ? filename : 'report'}_${dateStr}.csv`
  download_csv(csv.join("\n"), exportFilename)
}
